import { FIELD_TYPES } from "constants/template-field-type";
import { DEVLINK_COMPONENT_MAP } from "./constants/devlink-component-types";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Dynamic Devlink",
    fields: {
        devlinkComponent: {
            type: FIELD_TYPES.COMBO,
            label: "Component Type",
            options: Array.from(DEVLINK_COMPONENT_MAP.keys()).map((name)=>({
                    key: name,
                    text: name
                }))
        }
    }
};
